<template>
    <div class="tab-insurance">
        <div class="blockcont">
            <h2 class="smalltitle">Responsible Party <br> <span
                    style="font-weight: 200;font-size: 13px;">Please fill out these information below. This will help you setting up future appointment with our allergist immunologist.</span>
            </h2>
            <div class="prolabel  fullw">Who is responsible for payment?</div>
            <div class="profield  fullw checkbox">
                <input name="paymentchoice" type="radio" value="iam"
                       :disabled="disabledForm"
                       class="membertype" id="paymentchoice1"
                       v-model="insuranceInfo.payment">
                <label for="paymentchoice1">I am</label>
                <input name="paymentchoice" type="radio"
                       :disabled="disabledForm"
                       value="someone" class="membertype"
                       id="paymentchoice2"
                       v-model="insuranceInfo.payment">
                <label for="paymentchoice2">Someone else is</label>
            </div>
            <div class="paymentchoice2" v-show="insuranceInfo.payment == 'someone'">
                <div class="prolabel">First name</div>
                <div class="profield">
                    <input type="text" placeholder="First Name" :disabled="disabledForm"
                           v-model="insuranceInfo.paidFirstname"></div>
                <div class="prolabel">Last name</div>
                <div class="profield">
                    <input type="text" placeholder="Last Name" :disabled="disabledForm"
                           v-model="insuranceInfo.paidLastname"></div>
                <div class="prolabel">Address</div>
                <div class="profield">
                    <div class="row">
                        <div class="col-xs-4">
                            <input type="text" placeholder="Street Number" :disabled="disabledForm"
                                   v-model="insuranceInfo.paidStreetNumber"></div>
                        <div class="col-xs-4">
                            <input type="text" placeholder="Street Name" :disabled="disabledForm"
                                   v-model="insuranceInfo.paidStreetName"></div>
                        <div class="col-xs-4">
                            <input type="text" placeholder="Suite" :disabled="disabledForm"
                                   v-model="insuranceInfo.paidSuite"></div>
                    </div>
                    <div class="row">
                        <div class="col-xs-4"><input type="text" placeholder="City" :disabled="disabledForm"
                                                     v-model="insuranceInfo.paidCity"></div>
                        <div class="col-xs-4">
                            <select v-model="insuranceInfo.paidState" :disabled="disabledForm">
                                <option v-for="state in STATE" :value="state.name">{{state.name}}</option>
                            </select>
                        </div>
                        <div class="col-xs-4">
                            <input type="text" placeholder="Zip Code" :disabled="disabledForm"
                                   v-model="insuranceInfo.paidZip">
                        </div>
                    </div>

                    <div class="clear"></div>
                </div>
                <div class="prolabel">Relationship to Patient</div>
                <div class="profield">
                    <select v-model="insuranceInfo.paidRelated" :disabled="disabledForm">
                        <option :value="relate.code" v-for="relate in RELATIONSHIP_STATUS">{{relate.name}}</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="blockcont">
            <h2 class="smalltitle">Insurance Info</h2>
            <div class="prolabel fullw">Are you covered by insurance?</div>
            <div class="profield checkbox  fullw">
                <input name="insurancechoice" type="radio" value="yes"
                       class="yesnoselect" id="insurancechoice1"
                       :disabled="disabledForm"
                       v-model="insuranceInfo.insurance"><label
                    for="insurancechoice1">Yes</label>
                <input name="insurancechoice" type="radio"
                       :disabled="disabledForm"
                       value="no" class="yesnoselect"
                       id="insurancechoice2"
                       v-model="insuranceInfo.insurance"><label
                    for="insurancechoice2">No</label>
            </div>
            <div class="insuranceform" v-show="insuranceInfo.insurance == 'yes'">
                <div class="prolabel fullw note">Primary Insurance Policy Information</div>
                <div class="prolabel">Primary Insurance Card</div>
                <div class="prolabel fullw"><strong>Please upload photos of both sides of the insurance
                    card</strong></div>
                <div class="profield fullw">
                    <div class="row">
                        <div class="col-xs-6">
                            <div v-if="policy01.showUploadZonePrimaryCardFront"
                                 class="upload-drop-zone primary-card-front"></div>
                            <div v-if="policy01.showCurrentPrimaryCardFront" class="upload-drop-zone uploaded">
                                <div class="img" :style='getStyleCard(policy01.cardFront)'></div>
                            </div>

                        </div>
                        <div class="col-xs-6">
                            <div v-if="policy01.showUploadZonePrimaryCardBack"
                                 class="upload-drop-zone primary-card-back"></div>
                            <div v-if="policy01.showCurrentPrimaryCardBack" class="upload-drop-zone uploaded">
                                <div class="img" :style='getStyleCard(policy01.cardBack)'></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="prolabel fullw">Who is the primary insurance policy holder?</div>
                <div class="profield checkbox  fullw">
                    <input name="holderchoice" type="radio" value="valueiam" class="yesnoselect"
                           :disabled="disabledForm"
                           id="holderchoice1" grouptarget="holderform" v-model="policy01.who_is">
                    <label for="holderchoice1">I am</label>
                    <input name="holderchoice" type="radio" value="valuesomeone" class="yesnoselect"
                           :disabled="disabledForm"
                           id="holderchoice2" grouptarget="holderform" v-model="policy01.who_is">
                    <label for="holderchoice2">Someone else</label>
                </div>
                <div class="holderform" v-show="policy01.who_is=='valuesomeone'">
                    <div class="prolabel">First name</div>
                    <div class="profield"><input type="text" placeholder="First Name" :disabled="disabledForm"
                                                 v-model="policy01.firstName"></div>
                    <div class="prolabel">Last name</div>
                    <div class="profield"><input type="text" placeholder="Last Name" :disabled="disabledForm"
                                                 v-model="policy01.lastName"></div>
                    <div class="prolabel">Social Security Number (Optional)</div>
                    <div class="profield"><input type="text" placeholder="Social Security Number"
                                                 :disabled="disabledForm"
                                                 v-model="policy01.socialNumber"></div>
                    <div class="prolabel">Phone number</div>
                    <div class="profield"><input type="text" placeholder="Phone number" :disabled="disabledForm"
                                                 v-model="policy01.phoneNumber" name="phone"></div>
                    <div class="prolabel">Day of Birth</div>
                    <div class="profield">
                        <div class="row">
                            <div class="col-xs-4">
                                <select v-model="policy01.selectedDay" :disabled="disabledForm">
                                    <option :value="policy01.selectedDay"> {{policy01.selectedDay}}</option>
                                </select>
                            </div>
                            <div class="col-xs-4">
                                <select v-model="policy01.selectedMonth" :disabled="disabledForm">
                                    <option :value="policy01.selectedMonth"> {{policy01.selectedMonth}}</option>
                                </select></div>
                            <div class="col-xs-4">
                                <select v-model="policy01.selectedYear" :disabled="disabledForm">
                                    <option :value="policy01.selectedYear"> {{policy01.selectedYear}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="prolabel">Address</div>
                    <div class="profield">
                        <div class="row">
                            <div class="col-xs-4">
                                <input type="text" placeholder="Street number"
                                       :disabled="disabledForm"
                                       v-model="policy01.streetNumber">
                            </div>
                            <div class="col-xs-4">
                                <input type="text" placeholder="Street name" :disabled="disabledForm"
                                       v-model="policy01.streetName">
                            </div>
                            <div class="col-xs-4">
                                <input type="text" placeholder="Suite" :disabled="disabledForm"
                                       v-model="policy01.suite">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-4">
                                <input type="text" placeholder="City" :disabled="disabledForm" v-model="policy01.city">
                            </div>
                            <div class="col-xs-4">
                                <select v-model="policy01.state" :disabled="disabledForm">
                                    <option v-for="state in STATE" :value="state.name">{{state.name}}</option>
                                </select>
                            </div>
                            <div class="col-xs-4"><input type="text" placeholder="Zip Code" :disabled="disabledForm"
                                                         v-model="policy01.zipcode"></div>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <div class="prolabel">Employer Name</div>
                    <div class="profield">
                        <input type="text" placeholder="Employer Name" :disabled="disabledForm"
                               v-model="policy01.employerName">
                    </div>
                </div>
                <div class="prolabel">Insurance Carrier</div>
                <div class="profield">
                    <input type="text" placeholder="Employer Name"
                           v-model="policy01.insuranceCarrier" :disabled="disabledForm">
                </div>
                <div class="prolabel">Insurance Plan</div>
                <div class="profield">
                    <input type="text" placeholder="Employer Name"
                           v-model="policy01.insurancePlan" :disabled="disabledForm">
                </div>
                <div class="prolabel">Insurance ID / Policy #</div>
                <div class="profield"><input type="text" placeholder="Insurance ID / Policy #" :disabled="disabledForm"
                                             v-model="policy01.insurancePolicy"></div>
                <div class="prolabel">Group #</div>
                <div class="profield"><input type="text" placeholder="Group" :disabled="disabledForm"
                                             v-model="policy01.insuranceGroup"></div>
                <div class="prolabel">Insurance phone number</div>
                <div class="profield">
                    <input type="text" v-model="policy01.insurancePhoneNumber" :disabled="disabledForm" name="phone"/>
                </div>                                <!--second-->
                <div class="prolabel fullw">Do you have secondary insurance?</div>
                <div class="profield checkbox  fullw">
                    <input name="secondinsurancechoice" type="radio"
                           value="yes" class="yesnoselect"
                           id="secondinsurancechoice1"
                           :disabled="disabledForm"
                           v-model="policy02.insuranceSecond"><label
                        for="secondinsurancechoice1">Yes</label>
                    <input name="secondinsurancechoice"
                           type="radio"
                           value="no"
                           class="yesnoselect"
                           id="secondinsurancechoice2"
                           :disabled="disabledForm"
                           v-model="policy02.insuranceSecond"><label
                        for="secondinsurancechoice2">No</label>
                </div>
                <div class="secondinsuranceform" v-show="policy02.insuranceSecond=='yes'">
                    <div class="prolabel fullw note">Secondary Insurance Policy Information</div>

                    <div class="prolabel fullw">Secondary Insurance Card</div>
                    <div class="prolabel fullw"><strong>Please upload photos of both sides of the insurance
                        card</strong></div>
                    <div class="profield fullw">
                        <div class="row">
                            <div class="col-xs-6">

                                <div v-if="policy02.showUploadZoneSecondaryCardFront"
                                     class="upload-drop-zone secondary-card-front"
                                     options="secondaryCardFront" callbacks="dzCallbacks"
                                     methods="dzMethods" ng-dropzone></div>
                                <div v-if="policy02.showCurrentSecondaryCardFront"
                                     class="upload-drop-zone uploaded">
                                    <div class="img" :style='getStyleCard(policy02.cardFront)'></div>
                                </div>

                            </div>
                            <div class="col-xs-6">
                                <div v-if="policy02.showUploadZoneSecondaryCardBack"
                                     class="upload-drop-zone secondary-card-back"></div>
                                <div v-if="policy02.showCurrentSecondaryCardBack"
                                     class="upload-drop-zone uploaded">
                                    <div class="img" :style='getStyleCard(policy02.cardBack)'></div>

                                </div>

                            </div>
                        </div>
                        <div>
                            <div class="prolabel fullw">Who is the primary insurance policy holder?</div>
                            <div class="profield checkbox  fullw">
                                <input name="secondholderchoice" type="radio"
                                       value="valueiam" class="yesnoselect"
                                       id="secondholderchoice1"
                                       grouptarget="secondholderform"
                                       v-model="policy02.who_is"
                                       :disabled="disabledForm"
                                ><label for="secondholderchoice1">I am</label>
                                <input name="secondholderchoice"
                                       type="radio"
                                       value="valuesomeone"
                                       class="yesnoselect"
                                       id="secondholderchoice2"
                                       grouptarget="secondholderform"
                                       :disabled="disabledForm"
                                       v-model="policy02.who_is"><label
                                    for="secondholderchoice2">Someone else</label>
                            </div>
                            <div class="secondholderform" v-show="policy02.who_is=='valuesomeone'">
                                <div class="prolabel">First name</div>
                                <div class="profield"><input type="text" placeholder="First Name"
                                                             :disabled="disabledForm"
                                                             v-model="policy02.firstName"></div>
                                <div class="prolabel">Last name</div>
                                <div class="profield"><input type="text" placeholder="Last Name"
                                                             :disabled="disabledForm"
                                                             v-model="policy02.lastName"></div>
                                <div class="prolabel">Social Security Number (Optional)</div>
                                <div class="profield"><input type="text" :disabled="disabledForm"
                                                             placeholder="Social Security Number"
                                                             v-model="policy02.socialNumber"></div>
                                <div class="prolabel">Phone number</div>
                                <div class="profield"><input type="text" placeholder="Phone Number"
                                                             :disabled="disabledForm"
                                                             v-model="policy02.phoneNumber"
                                                             name="phone"></div>
                                <div class="prolabel">Day of Birth</div>
                                <div class="profield">
                                    <div class="row">
                                        <div class="col-xs-4">
                                            <select v-model="policy02.selectedDay" :disabled="disabledForm">
                                                <option :value="policy02.selectedDay"> {{policy02.selectedDay}}</option>
                                            </select>
                                        </div>
                                        <div class="col-xs-4">
                                            <select v-model="policy02.selectedMonth" :disabled="disabledForm">
                                                <option :value="policy02.selectedMonth"> {{policy02.selectedMonth}}
                                                </option>
                                            </select></div>
                                        <div class="col-xs-4">
                                            <select v-model="policy02.selectedYear" :disabled="disabledForm">
                                                <option :value="policy02.selectedYear"> {{policy02.selectedYear}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="prolabel">Address</div>
                                <div class="profield">

                                    <div class="row">
                                        <div class="col-xs-4"><input type="text" placeholder="Street number"
                                                                     :disabled="disabledForm"
                                                                     v-model="policy02.streetNumber">
                                        </div>
                                        <div class="col-xs-4"><input type="text" placeholder="Street name"
                                                                     :disabled="disabledForm"
                                                                     v-model="policy02.streetName">
                                        </div>
                                        <div class="col-xs-4"><input type="text" placeholder="Suite"
                                                                     :disabled="disabledForm"
                                                                     v-model="policy02.suite"></div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xs-4"><input type="text" placeholder="City"  :disabled="disabledForm"
                                                                     v-model="policy02.city"></div>
                                        <div class="col-xs-4">
                                            <select v-model="policy02.state" :disabled="disabledForm">
                                                <option v-for="state in STATE" :value="state.name">{{state.name}}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-xs-4"><input type="text" placeholder="Zip Code"
                                                                     :disabled="disabledForm"
                                                                     v-model="policy02.zipcode"></div>
                                    </div>
                                    <div class="clear"></div>
                                </div>
                                <div class="prolabel">Employer Name</div>
                                <div class="profield"><input type="text" placeholder="Employer Name"
                                                             :disabled="disabledForm"
                                                             v-model="policy02.employerName"></div>
                            </div>

                            <div class="prolabel">Insurance Carrier</div>
                            <div class="profield">
                                <input type="text" placeholder="Employer Name"
                                       v-model="policy02.insuranceCarrier" :disabled="disabledForm">
                            </div>
                            <div class="prolabel">Insurance Plan</div>
                            <div class="profield">
                                <input type="text" placeholder="Employer Name"
                                       v-model="policy02.insurancePlan" :disabled="disabledForm">
                            </div>

                            <div class="prolabel">Insurance ID / Policy #</div>
                            <div class="profield"><input type="text" placeholder="Insurance ID / Policy #"
                                                         :disabled="disabledForm"
                                                         v-model="policy02.insurancePolicy"></div>
                            <div class="prolabel">Group #</div>
                            <div class="profield"><input type="text" placeholder="Group" :disabled="disabledForm"
                                                         v-model="policy02.insuranceGroup"></div>
                            <div class="prolabel">Insurance phone number</div>
                            <div class="profield"><input type="text" :disabled="disabledForm"
                                                         v-model="policy02.insurancePhoneNumber"
                                                         name="phone"/>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import config from '../../../../config'
import CommonMixin from './../../../../mixins/general/CommonMixin.vue'
import httpClient from '../../../../client'

export default {
  name: 'TabInsurance',
  components: {},
  props: {
    userInfo: {},
    profile: {},
    disabledForm: {}
  },
  mixins: [CommonMixin],
  data () {
    return {
      RELATIONSHIP_STATUS: config.RELATIONSHIP_STATUS,
      STATE: config.STATE,
      insuranceInfo: {},
      policy01: {},
      policy02: {}
    }
  },
  computed: {},
  watch: {},
  updated () {
  },
  mounted () {
    if (this.profile) {
      if (this.profile.insurancePaid || this.profile.insurancePaid == true) {
        this.insuranceInfo.payment = 'iam'
      } else {
        this.insuranceInfo.payment = 'someone'
        this.insuranceInfo.paidFirstname = this.profile.paidFirstname
        this.insuranceInfo.paidLastname = this.profile.paidLastname
        this.insuranceInfo.paidState = this.profile.paidState
        this.insuranceInfo.paidCity = this.profile.paidCity
        this.insuranceInfo.paidZip = this.profile.paidZip
        this.insuranceInfo.paidStreetName = this.profile.paidStreetName
        this.insuranceInfo.paidStreetNumber = this.profile.paidStreetNumber
        this.insuranceInfo.paidSuite = this.profile.paidSuite
        this.insuranceInfo.paidRelated = this.profile.paidRelated
      }
      this.insuranceInfo.insurance = this.profile.insurance ? 'yes' : 'no'
    } else {
      this.insuranceInfo.payment = 'iam'
      this.insuranceInfo.insurance = 'no'
    }
    this.getInsurance()
    this.$forceUpdate()
  },
  beforeDestroy () {
  },
  methods: {
    getStyleCard (url) {
      let link = this.getLinkWiki('upload/cards/' + url)
      return `background-image: url("${link}")`
    },
    async getInsurance () {
      try {
        let response = await httpClient.get('/users/insurance/' + this.userInfo.id)
        if (response.data.s === 200) {
          let primary = response.data.data.primary
          let secondary = response.data.data.secondary

          if (primary) {
            if (primary.who_is) {
              this.policy01.who_is = 'valueiam'
            } else {
              this.policy01.who_is = 'valuesomeone'
              this.policy01.firstName = primary.firstName
              this.policy01.lastName = primary.lastName
              this.policy01.socialNumber = primary.socialNumber
              this.policy01.phoneNumber = primary.phoneNumber

              if (primary.birthday) {
                let date = new Date(primary.birthday)
                this.policy01.selectedDay = date.getDate()
                this.policy01.selectedMonth = date.getMonth() + 1
                this.policy01.selectedYear = date.getFullYear()
              }
              this.policy01.state = primary.state
              this.policy01.city = primary.city
              this.policy01.zipcode = primary.zipcode
              this.policy01.streetName = primary.streetName
              this.policy01.streetNumber = primary.streetNumber
              this.policy01.suite = primary.suite
              this.policy01.employerName = primary.employerName
            }
            this.policy01.insuranceCarrier = primary.insuranceCarrier
            this.policy01.insurancePlan = primary.insurancePlan
            this.policy01.insurancePolicy = primary.insurancePolicy
            this.policy01.insuranceGroup = primary.insuranceGroup
            this.policy01.cardFront = primary.cardFront
            if (this.policy01.cardFront) this.policy01.showCurrentPrimaryCardFront = true
            else this.policy01.showUploadZonePrimaryCardFront = true
            this.policy01.cardBack = primary.cardBack
            if (this.policy01.cardBack) this.policy01.showCurrentPrimaryCardBack = true
            else this.policy01.showUploadZonePrimaryCardBack = true
          } else {
            this.policy01.who_is = 'valueiam'
            this.policy01.showUploadZonePrimaryCardFront = true
            this.policy01.showUploadZonePrimaryCardBack = true
          }
          if (secondary) {
            if (secondary.who_is) {
              this.policy02.who_is = 'valueiam'
            } else {
              this.policy02.who_is = 'valuesomeone'
              this.policy02.firstName = secondary.firstName
              this.policy02.lastName = secondary.lastName
              this.policy02.socialNumber = secondary.socialNumber
              this.policy02.phoneNumber = secondary.phoneNumber

              if (secondary.birthday) {
                let date = new Date(secondary.birthday)
                this.policy02.selectedDay = date.getDate()
                this.policy02.selectedMonth = date.getMonth() + 1
                this.policy02.selectedYear = date.getFullYear()
              }

              this.policy02.state = secondary.state
              this.policy02.city = secondary.city
              this.policy02.zipcode = secondary.zipcode
              this.policy02.streetName = secondary.streetName
              this.policy02.streetNumber = secondary.streetNumber
              this.policy02.suite = secondary.suite
              this.policy02.employerName = secondary.employerName
            }
            this.policy02.insuranceCarrier = secondary.insuranceCarrier
            this.policy02.insurancePlan = secondary.insurancePlan
            this.policy02.insurancePolicy = secondary.insurancePolicy
            this.policy02.insuranceGroup = secondary.insuranceGroup
            this.policy02.insuranceSecond = 'yes'
            this.policy02.cardFront = secondary.cardFront
            if (this.policy02.cardFront) this.policy02.showCurrentSecondaryCardFront = true
            else this.policy02.showUploadZoneSecondaryCardFront = true
            this.policy02.cardBack = secondary.cardBack
            if (this.policy02.cardBack) this.policy02.showCurrentSecondaryCardBack = true
            else this.policy02.showUploadZoneSecondaryCardBack = true
          } else {
            this.policy02.who_is = 'valueiam'
            this.policy02.insuranceSecond = 'no'
            this.policy02.showUploadZoneSecondaryCardFront = true
            this.policy02.showUploadZoneSecondaryCardBack = true
          }
          this.$forceUpdate()
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.alertError('Error when load data insurance')
      }
    }
  }
}
</script>
<style scoped="">

</style>
